<div class="row ps-1 position-relative text-left">
  <b>{{ description }}</b>
</div>

<div class="uploader-container">
  @if (settings.multiple || selectedFiles.length === 0) {
  <div draggable="true" [ngClass]="dragAreaClass" (click)="fileInput.click()">
    <div class="row justify-content-center align-items-center text-center">
      <div class="col-12 files-drag-container">
        <h3 class="mb-0">Arrastrá y soltá</h3>
        <span>Arrastrá los archivos hasta acá</span>
        <button type="button" class="mx-auto">Adjuntar imágenes</button>
        <input type="file" #fileInput (change)="onFileChange($event)" style="display: none"
          [multiple]="settings.multiple" [accept]="settings.accept" />
      </div>
    </div>
  </div>
  }

  <div class="preview-gallery">
    @for (item of selectedFiles; track $index) {
    <div class="preview-item">
      <img [src]="item.preview" class="img-thumbnail" />
      @if (!settings.hideDelete) {
      <button class="btn-delete" (click)="removeFile($index)">
        <img src="../../../../assets/icons/common/delete.svg" alt="Eliminar" />
      </button>
      }
    </div>
    }
  </div>

  @if (error) {
  <div class="error">{{ error }}</div>
  }
</div>